import React from 'react';

import classes from 'components/common/CreateReportCard/CreateReportCard.module.scss';

import { Button } from 'components/DesignSystem/Button';

interface Props {
    title: string;
    titleIcon?: React.ReactNode;
    details: string;
    onClick: () => void;
    actionButtonChildren: React.ReactNode;
    actionButtonIcon?: React.ReactNode;
}

export const CreateReportCard = ({
    title,
    details,
    actionButtonChildren,
    onClick,
    actionButtonIcon,
    titleIcon,
}: Props) => {
    return (
        <div className={classes.createReportCardWrapper}>
            <div className={classes.titleRow}>
                <div className={classes.title}>{title}</div>
                <div className={classes.iconWrapper}>{titleIcon && titleIcon}</div>
            </div>

            <div className={classes.details}>{details}</div>

            <Button onClick={onClick} startIcon={actionButtonIcon ? actionButtonIcon : undefined}>
                {actionButtonChildren}
            </Button>
        </div>
    );
};
